import { render, staticRenderFns } from "./get-trust-popup.vue?vue&type=template&id=77bcd44c&scoped=true&"
import script from "./get-trust-popup.vue?vue&type=script&lang=js&"
export * from "./get-trust-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bcd44c",
  null
  
)

export default component.exports